package my.drivebit.maps.models

enum class MapProvider {
    OPENSTREETMAP,
    YANDEX_MAPS,
}
